import React from 'react';
import Header from '../components/Header';
import MainSection from '../components/MainSection';
import OverviewSection from '../components/OverviewSection';
import ServicesSection from '../components/ServicesSection';
import PricingSection from '../components/PricingSection';
import Footer from '../components/Footer';
import ScrollToTopButton from '../components/ScrollToTopButton';

export default function LandingPage() {
  return (
    <div className="landing-page home">
      <div className="page-wrapper">
        <Header />

        <main>
          <MainSection />
          <OverviewSection />
          <ServicesSection />
          <PricingSection />
        </main>

        <Footer />
      </div>

      <ScrollToTopButton />
    </div>
  );
}
